export default "__VITE_ASSET__CMzQqrKd__"